export const dataItems = [
    {
        title: "Locais de atendimento",
        subtitle: "Gerenciar locais, setores, filas e mais...",
        image: "/assets/images/locals.png",
        url: "/locais-de-atendimento",
        allowedRoles: [
            "Administrador de Atendimento",
            "Gerente de Atendimento",
            "Coordenador de Atendimento",
        ]
    },
    {
        title: "Totem",
        subtitle: "Quiosques e terminais de autoatendimentos",
        image: "/assets/images/totem.png",
        url: "/totens",
        allowedRoles: [
            "Administrador de Atendimento",
            "Gerente de Atendimento",
        ]
    },
    {
        title: "Prioridades",
        subtitle: "Gerenciar prioridades de atendentes",
        image: "/assets/images/priority.png",
        url: "/prioridades",
        allowedRoles: [
            "Administrador de Atendimento",
        ]
    },
    {
        title: "Atendentes",
        subtitle: "Gerenciamento de atendentes",
        image: "/assets/images/attendant.png",
        url: "/atendentes",
        allowedRoles: [
            "Administrador de Atendimento",
            "Gerente de Atendimento",
            "Coordenador de Atendimento",
        ]
    },
    {
        title: "Usuários",
        subtitle: "Administração de usuários",
        image: "/assets/images/users.png",
        url: "/usuarios",
        allowedRoles: [
            "Administrador de Atendimento",
            "Gerente de Atendimento",
            "Coordenador de Atendimento",
        ]
    },
    {
        title: "Cancelamentos",
        subtitle: "Gerenciar cancelamentos",
        image: "/assets/images/cancel.png",
        url: "/cancelamentos",
        allowedRoles: [
            "Administrador de Atendimento",
            "Gerente de Atendimento",
        ]
    },
    {
        title: "Reagendamentos",
        subtitle: "Relatórios de reagendamentos",
        image: "/assets/images/rescheduling.png",
        url: "/reagendamentos",
        allowedRoles: [
            "Administrador de Atendimento",
            "Gerente de Atendimento",
        ]
    },
];
